<template>
    <div class="cemetery-sectors-view">
        <div class="top">
            <div class="top-content">
                <a v-if="cemeteryName"
                    class="back-to-cemetery"
                    @click.prevent="onShowCemetery">
                    <div class="icon" aria-hidden="true">
                        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                            <path d="M20.4999 12H3.8999" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M6.4999 15L4.1999 12.7C3.7999 12.3 3.7999 11.7 4.1999 11.3L6.4999 9" stroke="currentcolor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </div>
                    <span class="name">{{ cemeteryName }}</span>
                </a>
                <div class="header">
                    <h3>{{ $t(`${baseTranslateID}.titles`) }}</h3>
                    <button
                        v-if="allowFilter"
                        type="button"
                        class="cemetery-sectors-filter btn"
                        :aria-label="`filter`"
                        @click.prevent="">
                        <span class="button-wrapper">
                            <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" fit="" preserveAspectRatio="xMidYMid meet" focusable="false">
                                <path d="M2.5 12H5.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M11.5 12H21.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M17.5 18.5H21.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M2.5 18.5H11.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M2.5 5.5H14.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M20.5 5.5H21.5" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M16.5 7.5C17.6046 7.5 18.5 6.60457 18.5 5.5C18.5 4.39543 17.6046 3.5 16.5 3.5C15.3954 3.5 14.5 4.39543 14.5 5.5C14.5 6.60457 15.3954 7.5 16.5 7.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M7.5 14C8.60457 14 9.5 13.1046 9.5 12C9.5 10.8954 8.60457 10 7.5 10C6.39543 10 5.5 10.8954 5.5 12C5.5 13.1046 6.39543 14 7.5 14Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                                <path d="M13.5 20.5C14.6046 20.5 15.5 19.6046 15.5 18.5C15.5 17.3954 14.6046 16.5 13.5 16.5C12.3954 16.5 11.5 17.3954 11.5 18.5C11.5 19.6046 12.3954 20.5 13.5 20.5Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
                            </svg>
                            <!-- <span class="filter-text">FILTER</span> -->
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="tree" id="treeSectors">
            <CemeterySectorList
                :value="sectors"
                :cemeteryCode="cemeteryCode"
                :panelCfg="panelCfg"
                :additional="additional"
                :baseTranslateID="baseTranslateID"
                @viewSector="onViewSector"
                @highlight="onHighlightFeature" />
        </div>
    </div>
</template>

<script>
    import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
    import { EVENTS as GLOBAL_EVENTS } from '@/app/shared/utils/constants';
    import { EVENTS } from '../../../shared/config/event-constants';

    export default {
        mixins: [
            CemeteryElementMixin
        ],
        components: {
            CemeterySectorList: () => import(/* webpackChunkName: "cemeteries-cemeterysectorlist" */ './../elements/CemeterySectorList'),
        },
        props: {
            value: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            eventCemeteryShow: {
                type: String,
                default: EVENTS.SHOW_MODAL_READ_CEMETERY,
            },
            eventSectorView: {
                type: String,
                default: EVENTS.SHOW_MODAL_DETAIL_SECTOR,
            },
        },
        data() {
            return {

            }
        },
        computed: {
            modelTranslateID() {
                return `${this.baseTranslateID}.model`
            },
            sectors() {
                return this.value ?? [];
            },
            cemetery() {
                return this.additional?.cemetery ?? {};
            },
            cemeteryName() {
                return this.cemetery.name;
            },
            cemeteryCode() {
                return this.cemetery.code;
            },
            allowFilter() {
                return false;
            }
        },
        methods: {
            onShowCemetery() {
                if(this.eventCemeteryShow) {
                    this.$eventBus.publish(this.moduleCode, this.eventCemeteryShow, {data: {code: this.cemeteryCode}});
                }
            },
            onViewSector(params={}) {
                if(this.eventSectorView) {
                    this.$eventBus.publish(
                        this.moduleCode,
                        this.eventSectorView,
                        {
                            data: params,
                        }
                    );
                }
            },
            onHighlightFeature(feature) {
                if(this.mapId && feature) {
                    this.$eventBus.publish(
                        this.moduleCode,
                        GLOBAL_EVENTS.HIGHLIGHT_FEATURE,
                        {
                            feature: feature,
                            mapId: this.mapId
                        }
                    );
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.cemetery-sectors-view {
    color: rgba(0, 0, 0, 0.87);

    .top {
        border-bottom: 1px solid rgba(24, 20, 41, 0.1);
        display: flex;
        flex-direction: column;

        .top-content {
            padding-bottom: 16px;

            .back-to-cemetery {
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon {
                    background-repeat: no-repeat;
                    display: inline-block;
                    color: var(--primary-color);
                    height: 24px;
                    width: 24px;
                }

                .name {
                    margin-left: 8px;
                    color: var(--primary-color);
                    font-size: 14px;
                    line-height: 1;
                }
            }

            .header {
                margin-top: 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                h3 {
                    font-family: inherit;
                    color: var(--primary-color);
                    margin: 0;
                }

                .btn {
                    box-sizing: border-box;
                    outline: none;
                    border: none;
                    -webkit-tap-highlight-color: transparent;
                    display: inline-block;
                    white-space: nowrap;
                    text-decoration: none;
                    vertical-align: baseline;
                    text-align: center;
                    margin: 0;
                    min-width: auto;
                    line-height: 36px;
                    padding: 0 0 0 16px;
                    overflow: visible;
                    color: var(--primary-color);

                    &:focus,
                    &:hover {
                        outline: 0;
                        box-shadow: none;
                        text-decoration: none;
                    }

                    .button-wrapper {
                        display: flex;
                        align-items: center;
                        -ms-flex-align: center;

                        svg {
                            background-repeat: no-repeat;
                            display: inline-block;
                            fill: currentColor;
                            height: 24px;
                            width: 24px;
                        }

                        .filter-text {
                            font-size: 16px;
                            line-height: 16px;
                            text-transform: uppercase;
                        }
                    }
                }
            }
        }
    }

}
</style>